{
  "name": "telespot",
  "private": true,
  "version": "5.3.0",
  "scripts": {
    "install:affected": "npx nx affected --target=install",
    "install:uncommitted": "NX_HEAD=HEAD NX_BASE=origin/$(git branch --show-current) npm run install:affected -- --uncommitted",
    "lint": "npx nx run-many --target=lint --quiet",
    "lint:affected": "npx nx affected --target=lint --quiet",
    "lint:uncommitted": "NX_HEAD=HEAD NX_BASE=origin/$(git branch --show-current) npm run lint:affected -- --uncommitted",
    "test": "NODE_OPTIONS=--experimental-vm-modules npx nx run-many --target=test --parallel=1",
    "test:affected": "NODE_OPTIONS=--experimental-vm-modules npx nx affected --target=test --parallel=1",
    "test:uncommitted": "NX_HEAD=HEAD NX_BASE=origin/$(git branch --show-current) npm run test:affected -- --uncommitted",
    "test:int": "npx nx run-many --target=test:int --parallel=1",
    "test:int:affected": "npx nx affected --target=test:int --parallel=1",
    "test:int:uncommitted": "NX_HEAD=HEAD NX_BASE=origin/$(git branch --show-current) npm run test:int:affected -- --uncommitted",
    "test:e2e": "npx nx run-many --target=test:e2e --parallel=1",
    "test:e2e:affected": "npx nx affected --target=test:e2e --parallel=1",
    "cy:ct": "npx nx run-many -t component-test",
    "cy:ct:chrome": "npx nx run-many -t component-test --browser=chrome",
    "cy:ct:firefox": "npx nx run-many -t component-test --browser=firefox",
    "cy:ct:open": "npx nx run telespot-e2e:component-test --watch",
    "cy:e2e": "npx nx run-many -t test:e2e --parallel=1",
    "cy:e2e:chrome": "npx nx run-many -t test:e2e --parallel=1 --browser=chrome",
    "cy:e2e:firefox": "npx nx run-many -t test:e2e --parallel=1 --browser=firefox",
    "cy:e2e:edge": "npx nx run-many -t test:e2e --parallel=1 --browser=edge",
    "coverage": "node scripts/combine-coverage.js",
    "report:traceability": "node scripts/build-traceability.mjs",
    "build:report": "npx nx run-many --target=build:report",
    "build": "npx nx run-many --target=build",
    "build:affected": "npx nx affected --target=build",
    "build:uncommitted": "NX_HEAD=HEAD NX_BASE=origin/$(git branch --show-current) npm run build:affected -- --uncommitted",
    "package": "npx nx run-many --target=package",
    "package:affected": "npx nx affected --target=package",
    "package:uncommitted:dev": "NX_HEAD=HEAD NX_BASE=origin/$(git branch --show-current) ENVIRONMENT=dev npm run package:affected -- --uncommitted",
    "deploy": "npx nx run-many --target=deploy --exclude=config",
    "deploy:affected": "npx nx affected --target=deploy --exclude=config",
    "deploy:standalone:affected": "npx nx affected --target=deploy:standalone --exclude=config",
    "deploy:uncommitted:dev": "NX_HEAD=HEAD NX_BASE=origin/$(git branch --show-current) ENVIRONMENT=dev npm run deploy:affected -- --uncommitted -c $ENVIRONMENT",
    "deploy:standalone:uncommitted": "NX_HEAD=HEAD NX_BASE=origin/$(git branch --show-current) npm run deploy:standalone:affected -- --uncommitted -c $ENVIRONMENT",
    "commit": "cz",
    "prepare": "husky",
    "preserve": "docker compose -f docker/docker-compose.dev.yml up -d",
    "serve": "npx nx run-many --target=serve --all",
    "validate-template": "npx nx run-many --target=validate-template",
    "validate-template:affected": "npx nx affected --target=validate-template",
    "build:docs": "npx nx run-many --target=docs",
    "postbuild:docs": "typedoc --options typedoc.json",
    "graph:uncommitted": "NX_HEAD=HEAD NX_BASE=origin/$(git branch --show-current) npx nx affected:graph --uncommitted --watch"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/malariaspot/telespot.git"
  },
  "keywords": [],
  "author": "Spotlab SL",
  "license": "ISC",
  "bugs": {
    "url": "https://github.com/malariaspot/telespot/issues"
  },
  "homepage": "https://github.com/malariaspot/telespot#readme",
  "description": "AI Powered cloud platform for managing and analysing medical assets.",
  "dependencies": {
    "@angular/animations": "19.2.22",
    "@angular/cdk": "19.2.19",
    "@angular/common": "19.2.22",
    "@angular/compiler": "19.2.22",
    "@angular/core": "19.2.22",
    "@angular/forms": "19.2.22",
    "@angular/material": "19.2.19",
    "@angular/platform-browser": "19.2.22",
    "@angular/platform-browser-dynamic": "19.2.22",
    "@angular/router": "19.2.22",
    "@angular/service-worker": "19.2.22",
    "@aws-lambda-powertools/batch": "2.31.0",
    "@aws-lambda-powertools/idempotency": "2.31.0",
    "@aws-lambda-powertools/logger": "2.31.0",
    "@aws-lambda-powertools/metrics": "2.31.0",
    "@aws-sdk/client-apigatewaymanagementapi": "3.982.0",
    "@aws-sdk/client-dynamodb": "3.982.0",
    "@aws-sdk/client-lambda": "3.982.0",
    "@aws-sdk/client-s3": "3.982.0",
    "@aws-sdk/client-sfn": "3.982.0",
    "@aws-sdk/client-sns": "3.982.0",
    "@aws-sdk/client-sqs": "3.982.0",
    "@aws-sdk/client-ssm": "3.982.0",
    "@aws-sdk/credential-providers": "3.982.0",
    "@aws-sdk/lib-dynamodb": "3.982.0",
    "@aws-sdk/util-dynamodb": "3.982.0",
    "@aws-sdk/s3-request-presigner": "3.982.0",
    "@ngneat/hotkeys": "^1.1.0",
    "@ngrx/component-store": "19.2.1",
    "@ngrx/effects": "19.2.1",
    "@ngrx/entity": "19.2.1",
    "@ngrx/operators": "19.2.1",
    "@ngrx/router-store": "19.2.1",
    "@ngrx/schematics": "19.2.1",
    "@ngrx/store": "19.2.1",
    "@ngrx/store-devtools": "19.2.1",
    "@ngx-translate/core": "^16.0.0",
    "@ngx-translate/http-loader": "^16.0.0",
    "@parse/s3-files-adapter": "^4.0.0",
    "@storybook/addon-interactions": "8.6.18",
    "ajv": "^8.17.0",
    "angularx-qrcode": "^19.0.0",
    "bootstrap": "^5.0.2",
    "chroma-js": "^2.4.2",
    "cli-progress": "^3.12.0",
    "commander": "^9.4.1",
    "csv-parse": "^5.5.2",
    "dotenv": "^16.0.3",
    "ejs": "^3.1.8",
    "email-templates": "^13.0.1",
    "express": "4.22.1",
    "file-saver": "^2.0.2",
    "fluent-ffmpeg": "^2.1.2",
    "html2canvas": "^1.4.1",
    "idb": "^8.0.3",
    "inquirer": "^8.2.5",
    "jsonpath": "^1.1.1",
    "jspdf": "^4.2.1",
    "jszip": "^3.6.0",
    "ngx-cookie-service": "^11.0.2",
    "nodemailer": "^8.0.7",
    "openseadragon": "^2.4.2",
    "parse": "^5.3.0",
    "parse-server": "^7.5.0",
    "remixicon": "^4.0.0",
    "rxjs": "~7.8.0",
    "sharp": "^0.33.5",
    "smartlook-client": "^5.0.0",
    "stacktrace-js": "^2.0.2",
    "storybook": "^8.2.8",
    "tslib": "^2.0.0",
    "uid": "^1.0.0",
    "video-thumbnail-generator": "^1.0.8",
    "winston": "^3.8.2",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.26",
    "@angular-devkit/core": "19.2.26",
    "@angular-devkit/schematics": "19.2.26",
    "@angular-eslint/eslint-plugin": "19.8.1",
    "@angular-eslint/eslint-plugin-template": "19.8.1",
    "@angular-eslint/template-parser": "19.8.1",
    "@angular/cli": "~19.2.0",
    "@angular/compiler-cli": "19.2.22",
    "@angular/language-service": "19.2.22",
    "@commitlint/cli": "^17.4.2",
    "@commitlint/config-conventional": "^17.4.2",
    "@cypress/webpack-dev-server": "^5.6.2",
    "@nx/angular": "20.8.4",
    "@nx/cypress": "20.8.4",
    "@nx/esbuild": "20.8.4",
    "@nx/eslint": "20.8.4",
    "@nx/eslint-plugin": "20.8.4",
    "@nx/jest": "20.8.4",
    "@nx/node": "20.8.4",
    "@nx/storybook": "20.8.4",
    "@nx/workspace": "20.8.4",
    "@schematics/angular": "19.2.26",
    "@storybook/addon-essentials": "8.6.18",
    "@storybook/angular": "8.6.18",
    "@storybook/core-server": "8.6.18",
    "@types/aws-lambda": "^8.10.103",
    "@types/cli-progress": "^3.11.0",
    "@types/dotenv": "^4.0.3",
    "@types/email-templates": "^10.0.4",
    "@types/express": "4.17.25",
    "@types/html2canvas": "0.0.35",
    "@types/inquirer": "^8.2.1",
    "@types/jest": "29.5.14",
    "@types/jsonpath": "^0.2.0",
    "@types/lodash": "^4.14.191",
    "@types/node": "22.0.0",
    "@types/nodemailer": "^7.0.2",
    "@types/openseadragon": "^2.4.4",
    "@types/parse": "^2.18.13",
    "@types/uuid": "^9.0.8",
    "@typescript-eslint/eslint-plugin": "7.18.0",
    "@typescript-eslint/parser": "7.18.0",
    "@typescript-eslint/utils": "^7.16.0",
    "caniuse-lite": "^1.0.30001002",
    "cypress": "^15.0.0",
    "cypress-multi-reporters": "^1.4.0",
    "cz-conventional-changelog": "^3.3.0",
    "esbuild": "^0.19.2",
    "eslint": "8.57.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-cypress": "2.15.2",
    "eslint-plugin-import": "2.22.1",
    "eslint-plugin-jsdoc": "30.7.6",
    "eslint-plugin-prefer-arrow": "1.2.2",
    "husky": "^9.1.0",
    "istanbul-lib-coverage": "^3.2.2",
    "istanbul-lib-report": "^3.0.1",
    "istanbul-reports": "^3.2.0",
    "jest": "29.7.0",
    "jest-environment-jsdom": "29.7.0",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "14.4.2",
    "mochawesome": "^7.1.3",
    "mochawesome-merge": "^4.2.2",
    "mochawesome-report-generator": "^6.2.0",
    "mongodb": "^6.0.0",
    "mongodb-memory-server": "^10.1.4",
    "nx": "20.8.4",
    "prettier": "2.8.1",
    "ts-jest": "29.1.5",
    "ts-node": "10.9.1",
    "tsconfig-paths": "^4.2.0",
    "tslib": "^2.3.0",
    "typedoc": "^0.24.6",
    "typescript": "5.7.3",
    "webpack": "^5.64.0"
  },
  "browser": {
    "crypto": false
  },
  "overrides": {
    "nodemailer": "$nodemailer"
  },
  "engines": {
    "node": ">=22.0.0"
  }
}
